module.exports = __webpack_public_path__ + "img/材料力学8_2_1.88c63bc0.jpg";